<template>
  <div class="sub-menu-details sub-menu">
    <!-- Details long description -->
    <div
      v-if="content.details.text"
      class="sub-menu-details__long"
    >
      <div
        class="text-desktop-14-desktop text-mobile-12-mobile rte"
        v-html="productContentDetails"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Sub menu details
 * -----------------------------------------------------------------------------
 * Details & fit sub menu component.
 *
 * @param {Object} content - Content to be displayed.
 */
export default {
  name: 'SubMenuDetails',

  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    productContentDetails() {
      const parser = new DOMParser()
      const decodedString = parser.parseFromString(this.content.details.text, 'text/html').body.textContent
      return decodedString
    },
  },
}
</script>
